import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const list = async (data: { page: number; limit: number; query?: string }) => {
  const res = await httpRequest.get('/api/user', data);
  return res;
};

export const create = async (data: { name: string; nameEng: string }) => {
  const res = await httpRequest.post('/api/user', data);
  return res;
};

export const get = async (id: string) => {
  const res = await httpRequest.get(`/api/user/${id}/detail`);
  return res;
};

export const me = async () => {
  const res = await httpRequest.get(`/api/auth/me`);
  const permissions = (res.permissions || []).reduce((acc: any, item: any) => {
    acc[item.code] = item;
    return acc;
  }, {} as Record<string, any>);
  return {
    ...res,
    permissions: permissions,
  };
};

export const remove = async (id: string) => {
  const res = await httpRequest.del(`/api/user/${id}`);
  return res;
};

export const update = async ({ id, ...props }: { id: string; name: string; nameEng: string }) => {
  const res = await httpRequest.put(`/api/user/${id}/update`, props);
  return res;
};

export const changeStatus = async (id: string, status: 'ACTIVE' | 'INACTIVE') => {
  const res = await httpRequest.put(`/api/user/${id}/status`, {
    status: status,
  });
  return res;
};

export const select = async (payload: any) => {
  const res = await httpRequest.get(`/api/user/select`, {
    ...payload,
    limit: 10000,
  });
  return res;
};
